import React from 'react'
import { Link } from "react-router-dom";

import { GiCargoShip } from "react-icons/gi";
import { GoLocation } from "react-icons/go";
import { RiCustomerService2Fill } from "react-icons/ri";

import '../styles/eta.css'
const ETA = () => {
  return (
    <>
      <div className="eta">
        <div className="eta-cont">
          <div className="foot-nav">
        <div className="logo"><Link to="/"><h2><GiCargoShip /></h2><h4>onTrac <span>Global</span></h4></Link><h5>Courier & Cargo</h5></div>
          </div>
          <div className="etas">
            <RiCustomerService2Fill />
            <ul>
              <h4>Mail Us</h4>
              <li><p>24/7 Support</p></li>
              {/* <li><a href="mailto:admin@finelinesupport.online"><p>admin@finelinesupport.online</p></a></li> */}
            </ul>
          </div>
          <div className="etas">
            <GoLocation />
            <ul>
              <h4>Location</h4>
              <li><p>normanton, united kingdom</p></li>
              <li><p>7 Rosedale Cl, Normanton WF6 1UQ</p></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default ETA